export const customTags = [
  'App',
  'Dashboard',
  'File',
  'Notification',
  'Report',
  'SuperAdminAgents',
  'SuperAdminPrompts',
  'SuperAdminInteractions',
];
